import Martin from "@images/team/martin.webp";
import Linda from "@images/team/linda.webp";

export const TeamMembers: any = {
  linda: Linda,
  martin: Martin,
};
